export const PATH = "/patents/query";
